export default __webpack_public_path__ + "static/media/features11.787eb5a6.png";